<template>
    <div v-if="news.total" ref="newsPane">
        <div class="mb-3" v-if="fixed_news && (!$route.params.id || fixed_news.id == $route.params.id)">
            <news-card
                :fixed="true"
                :news="fixed_news"
                @load="load($event)"
                @opened="opened($event)"
                @closed="closed()"
                @showR18="showR18"></news-card>
        </div>
        <news-card v-for="n in filteredNews" :key="n.id"
            :news="n"
            @load="load($event)"
            @opened="opened($event)"
            @closed="closed()"
            @showR18="showR18"></news-card>
        <div v-if="!$route.params.id">
            <page :last_page="news.last_page" v-model="page" @goto="goto($event)"></page>
        </div>
    </div>
</template>

<script>
import page from "components/Page";
import newsCard from "./newsCard";
export default {
    components: {
        page,
        newsCard
    },
    data() {
        return {
            news: [],
            fixed_news: null,
            page: this.$route.query.page || 1,
            imgs: [],
            showLightbox: false,
            isLoading: false,
            opened_id: null,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            this.$router.push({query: {page: p}});
            setTimeout(() => {this.load()});
            const offsetTop = this.$refs.newsPane.getBoundingClientRect().top + window.scrollY - 100;
            $("html,body").animate({scrollTop: offsetTop}, 300);
        },
        load(scrollTop = null) {
            if (scrollTop !== null) {
                $("html,body").animate({scrollTop: scrollTop}, 0);
            }
            this.isLoading = true;
            axios.get("/author/news/get", {params: {
                page: this.page,
                id: this.$route.params.id || null
            }}).then(res => {
                this.news = res.data.news;
                this.fixed_news = res.data.fixed_news;
                this.isLoading = false;
            }).catch(err => { alert.err(err.response) });
        },
        showR18() {
            $("#r18-modal").modal();
        },
        connectChannel() {
            // ランディング時にstore初期化が間に合わない、直接サブドメインを取る。
            const uri = new URL(window.location.href);
            const domain = uri.hostname.split(/\./);
            const subdomain = domain.shift().toLocaleLowerCase();
            Echo.channel("news." + subdomain).listen("News\\NewsUpdate", (e) => {
                this.load();
            });
        },
        opened(id) {
            this.opened_id = id;
        },
        closed() {
            this.opened_id = null;
        },
    },
    computed: {
        filteredNews() {
            if (this.$route?.params?.id && this.news?.data) {
                const res = _.find(this.news.data, {id: parseInt(this.$route.params.id)});
                if (!res) return [];
                return [res];
            }
            return this.news.data;
        },
    },
    mounted() {
        this.load();
        this.connectChannel();
    },
    unmounted() {
        Echo.leaveChannel("news." + this.$store.state.subdomain);
    }
}
</script>